<template>
	<div class="fooCon">
		<div class="content">
			<div class="left">
				<div class="title">
					准聘
				</div>
				<div class="other">
					企业服务热线和算法推荐/未成年人举报渠道：  400 - 101 - 8699
				</div>
				<div class="other">
					工作日：8:00 - 22:00
				</div>
				<div class="other">
					邮箱：service@zhunpin.work
				</div>
				<div class="other">
					地址：成都市武侯区高阳路75号寰球创联中心11楼
				</div>
				<div class="other" @click="toLink('aboutUs')" style="cursor: pointer;">
					关于我们
				</div>
				<div class="info">
					Copyright@2024  
					<span @click="toLink('aboutUs')">成都三角形人力资源服务有限公司</span>    
					<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/recordQuery">蜀ICP备2021002815号-5</a>    
					<span>人力许可证号: 510112101035</span>
				</div>
			</div>
			<div class="right">
				<div class="title">
					扫码进入小程序
				</div>
				<img src="@/static/qrcode.jpg" class="qrcode" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:'foo',
		data() {
			return {
				
			}
		},
		created() {

		},
		methods: {
			toLink(name){
				this.$router.push({ name });
			}
		}
	}
</script>

<style lang="scss" scoped>
	.fooCon{
		// width: 100vw;
		// height: 390px;
		background-color: #353746;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.content{
		width: 1200px;
		height: 325px;
		color: #A3A7B3;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.left{
			.title{
				font-size: 32px;
				font-weight: bold;
				margin-bottom: 16px;
			}
			.other{
				font-size: 16px;
				margin-bottom: 16px;
			}
			.info{
				font-size: 16px;
				margin-top: 38px;
				span,a{
					margin-left: 18px;
					cursor: pointer;
					&:hover{
						color: #51A190;
					}
					
				}
			}
		}
		.right{
			.title{
				font-size: 23px;
				margin-bottom: 16px;
			}
			.qrcode{
				width: 160px;
				height: 160px;
			}
		}
	}
</style>